export default "__VITE_ASSET__9b1eac94__"